import classNames from "classnames";
import React from "react";
import styles from "Styles/NamePage/NameInfoContent.module.css";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";

export const NameInfoContent = () => {
  const nameInfoClassNames = classNames(styles.nameInfo);

  const nameInfoParagraphClassNames = classNames(styles.nameInfoParagraph);

  const nameInfoSVGClassNames = classNames(styles.nameInfoSVG);

  return (
    <InfoContentMotionWrapper className={nameInfoClassNames}>
      <p className={nameInfoParagraphClassNames}>
        開始之前，為了讓我們更近一步的認識你，請問你的名字是？
      </p>
      <svg
        className={nameInfoSVGClassNames}
        width="197"
        height="65"
        viewBox="8.83 8.76 179.06 47.25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45.6029 45.5063L51.8016 45.856L49.3001 40.169L55.2547 38.3735L50.9598 33.8934L55.9505 30.1677L50.3791 27.437L53.8019 22.2308L47.6266 21.5756L49.0721 15.517L43.0391 17.0196L42.3296 10.8389L37.1639 14.3167L34.3888 8.75912L30.7142 13.7925L26.2049 9.52943L24.4668 15.5122L18.7683 13.0581L19.1739 19.2666L12.9735 18.9159L15.4751 24.6029L9.52042 26.3983L13.8153 30.8785L8.82628 34.6051L14.3977 37.3358L10.9749 42.542L17.1485 43.1963L15.7048 49.2558L21.7378 47.7532L22.4472 53.934L27.6113 50.4552L30.388 56.0137L34.061 50.9793L38.5703 55.2424L40.31 49.2607L46.0085 51.7148L45.6029 45.5063Z"
          fill="#FCCA23"
        ></path>
        <path
          d="M111.536 45.5063L117.735 45.856L115.234 40.169L121.188 38.3735L116.893 33.8934L121.884 30.1677L116.313 27.437L119.735 22.2308L113.56 21.5756L115.006 15.517L108.973 17.0196L108.263 10.8389L103.097 14.3167L100.322 8.75912L96.6477 13.7925L92.1385 9.52943L90.4004 15.5122L84.7019 13.0581L85.1075 19.2666L78.9071 18.9159L81.4087 24.6029L75.454 26.3983L79.7489 30.8785L74.7599 34.6051L80.3313 37.3358L76.9085 42.542L83.0821 43.1963L81.6384 49.2558L87.6714 47.7532L88.3808 53.934L93.5449 50.4552L96.3216 56.0137L99.9946 50.9793L104.504 55.2424L106.244 49.2607L111.942 51.7148L111.536 45.5063Z"
          fill="#FCCA23"
        ></path>
        <path
          d="M177.536 45.5063L183.735 45.856L181.234 40.169L187.188 38.3735L182.893 33.8934L187.884 30.1677L182.313 27.437L185.735 22.2308L179.56 21.5756L181.006 15.517L174.973 17.0196L174.263 10.8389L169.097 14.3167L166.322 8.75912L162.648 13.7925L158.138 9.52943L156.4 15.5122L150.702 13.0581L151.108 19.2666L144.907 18.9159L147.409 24.6029L141.454 26.3983L145.749 30.8785L140.76 34.6051L146.331 37.3358L142.909 42.542L149.082 43.1963L147.638 49.2558L153.671 47.7532L154.381 53.934L159.545 50.4552L162.322 56.0137L165.995 50.9793L170.504 55.2424L172.244 49.2607L177.942 51.7148L177.536 45.5063Z"
          fill="#FCCA23"
        ></path>
      </svg>
    </InfoContentMotionWrapper>
  );
};
